module.exports = __webpack_public_path__ + "img/tu03.fa6521a6.jpg";